"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const enforceDate_1 = __importDefault(require("../../utils/enforceDate"));
async function getFriendships(token) {
    return await fetch(`${this.baseUrl}/Social/Friends/GetFriends`, {
        duplex: "half",
        headers: {
            "token": token
        }
    })
        .then(x => x.json())
        .then(x => (0, enforceDate_1.default)(x))
        .then(x => x)
        .catch(() => ({ error: { code: "networkError", message: "A network error happened" } }));
}
exports.default = getFriendships;
//# sourceMappingURL=getFriendships.js.map